import client from './client';

// Seed mailbox = a real external mailbox (e.g. a Gmail seed account) that
// campaign test emails are sent to so inbox-vs-spam placement can be
// checked over IMAP.
export interface SeedMailbox {
  id: number;
  label: string;
  email: string;
  imap_host: string;
  imap_port: number;
  imap_username: string;
  imap_password?: string;
  ignore_cert: boolean;
  created_at: string;
}

export interface SeedMailboxInput {
  label: string;
  email: string;
  imap_host: string;
  imap_port: number;
  imap_username: string;
  imap_password: string;
  ignore_cert: boolean;
}

export type SeedFolder = 'inbox' | 'spam' | '';
export type SeedTestStatus =
  | 'sent'
  | 'send_failed'
  | 'inbox'
  | 'spam'
  | 'not_found'
  | 'check_failed';

export interface SeedTest {
  id: number;
  campaign_id: number;
  seed_mailbox_id: number;
  match_subject: string;
  sent_at: string | null;
  folder: SeedFolder;
  checked_at: string | null;
  status: SeedTestStatus;
  error?: string;
}

// Per-mailbox outcome from POST /api/campaigns/{id}/seed-test.
export interface SeedSendResult {
  seed_test_id: number;
  seed_mailbox_id: number;
  email: string;
  status: string;
  error?: string;
}

export interface DeliveryMetrics {
  campaign_id: number;
  sent: number;
  delivered: number;
  bounced: number;
  bounce_rate: number;
  opened: number;
  clicked: number;
  submitted: number;
  reported: number;
  inbox_estimated: boolean;
}

// GET /api/campaigns/{id}/delivery response: metrics plus the campaign's
// delivery label ("unwhitelisted" | "standard").
export interface CampaignDelivery extends DeliveryMetrics {
  label: string;
}

export const deliverabilityApi = {
  listSeeds: () => client.get<SeedMailbox[]>('/seeds/'),

  createSeed: (data: SeedMailboxInput) => client.post<SeedMailbox>('/seeds/', data),

  deleteSeed: (id: number) => client.delete(`/seeds/${id}`),

  runSeedTest: (campaignId: number) =>
    client.post<{ success: boolean; data: SeedSendResult[] }>(
      `/campaigns/${campaignId}/seed-test`
    ),

  listSeedTests: (campaignId: number) =>
    client.get<SeedTest[]>(`/campaigns/${campaignId}/seed-tests`),

  checkPlacement: (seedTestId: number) =>
    client.post<SeedTest>(`/seed-tests/${seedTestId}/check`),

  delivery: (campaignId: number) =>
    client.get<CampaignDelivery>(`/campaigns/${campaignId}/delivery`),
};
